import React, { useState } from 'react';
import PoolTypeListTable from './Components/PoolTypeListTable';
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import AddPoolType from '../AddPoolType/AddPoolType';
import { useRoleVerify } from 'Common/RoleVerify';

const PoolTypeList = () => {
    const [refetch, setRefetch] = useState(false)
    const canShowAction = useRoleVerify("", ["can_create"]);
    return (
        <>
            {canShowAction &&
                <AddPoolType
                    setRefetch={setRefetch}
                    refetch={refetch}
                />}

            <PageBody
                card={true}
                headerchildren={
                    <>
                        <HeadingOne>Pool Type List</HeadingOne>
                    </>
                }>

                {/* Table section */}
                <div className="col-12">
                    <PoolTypeListTable refetch={refetch} />
                </div>
            </PageBody>
        </>
    );
};

export default PoolTypeList;
